module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_7005.13a7535b.png";